// Session replay (#811): `POST /v1/sessions/:id/replay` — a READ-ONLY dry-run
// of a stored session's policy decision points against a candidate
// `.maintainer.yml`. Executes nothing, writes nothing; the response is the
// decisions diff. Shapes mirror apps/api/src/routes/session-replay.ts →
// packages/agent/src/replay/policy-diff.ts (`PolicyReplayDecision`/`Diff`).

import { apiFetch } from './api';
import { SESSION_TOKEN } from './session';

export type ReplayDecision = {
  readonly audit_event_id: string;
  readonly kind: string;
  /** ISO instant the original decision was recorded. */
  readonly at: string;
  /** Present for `policy.gate.refused`. */
  readonly capability?: string;
  /** Present for `escalation.fired`. */
  readonly category?: string;
  /** True when the candidate policy would have decided differently. */
  readonly changed: boolean;
  readonly original: string;
  readonly replayed: string;
  readonly detail?: string;
};

export type ReplayDiff = {
  readonly session_id: string;
  readonly policy_hash: string;
  readonly decisions: readonly ReplayDecision[];
  readonly changed_count: number;
  readonly unsupported_kinds: readonly string[];
};

/** Dry-run `sessionId` against a candidate policy. A 400 (invalid candidate /
 * body) surfaces as `ApiError` for the panel to render inline. */
export function replaySession(
  sessionId: string,
  yml: string,
  token: string | null = SESSION_TOKEN,
): Promise<ReplayDiff> {
  return apiFetch<ReplayDiff>(`/v1/sessions/${encodeURIComponent(sessionId)}/replay`, token, {
    method: 'POST',
    body: JSON.stringify({ yml }),
  });
}
